var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_vm._v(" "),_c('main',{staticClass:"app-main"},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('message'),_vm._v(" "),_c('confirm'),_vm._v(" "),_c('app-loading')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aa1d086","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 